import { animate, state, style, transition, trigger } from "@angular/animations";
import { CdkTrapFocus } from "@angular/cdk/a11y";
import { Component, signal } from "@angular/core";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatomoTracker } from "ngx-matomo-client";

@Component({
    selector: "app-pwa-guide",
    imports: [MatIcon, MatButton, MatButtonModule, CdkTrapFocus],
    templateUrl: "./pwa-guide.component.html",
    styleUrl: "./pwa-guide.component.scss",
    animations: [trigger("fadeInOut", [state("void", style({ opacity: 0 })), transition("void <=> *", [animate(200)])])]
})
export class PwaGuideComponent {
    constructor(private matomo: MatomoTracker) {}

    public showModal = signal(false);
    public selectedTab = signal<"windows" | "mac" | "ios" | "android">("windows");
    public isClosing = false;

    public isUsingPwa() {
        return window.matchMedia("(display-mode: standalone)").matches || (window.navigator as any).standalone === true;
    }

    public togglePwaGuide() {
        this.detectDevice();
        setTimeout(() => {
            this.showModal.update((value) => !value);
            this.matomo.trackEvent("Supportsystem", "PWA-Guide", "Open");
        }, 100);
    }

    public closePwaGuide() {
        this.isClosing = true;
        setTimeout(() => {
            this.showModal.set(false);
            this.isClosing = false;
        }, 350);
    }

    public setTab(tab: "windows" | "mac" | "ios" | "android") {
        this.selectedTab.set(tab);
    }

    detectDevice() {
        const ua = window.navigator.userAgent;
        if (/android/i.test(ua)) return this.setTab("android");
        if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream) return this.setTab("ios");
        if (/Win/.test(ua)) return this.setTab("windows");
        if (/Mac/.test(ua)) return this.setTab("mac");
    }
}
